// A UISession expires when either the date changes (midnight, client time), or when the user was away from the site for more than SESSION_TIME_MILLIS.
// When the user clicks the mouse, we “touch” the session to mark the user’s last interaction with the site.
// When the sessionID is requested, we verify the session was not expired yet. If not - we return the old session ID. Otherwise - we reset the session ID and return a new value.

import uuid from 'uuid'

const UI_SESSION_INFO_KEY = 'UISessionInfo'
const SESSION_TIME_MILLIS = 1000 * 60 * 30

export default class UISessionManager {

  constructor() {
    if (window && localStorage) {
      window.addEventListener('click', this._clickHandler, true)
    }
  }

  _clickHandler = () => {
    const clickTime = new Date()

    if (this.isSessionExpired()) {
      this._createSessionInfo({sessionTouched: clickTime})
    } else {
      // continue existing session
      const sessionInfo = this._getSessionInfo()
      const {sessionId} = sessionInfo
      localStorage.setItem(UI_SESSION_INFO_KEY, JSON.stringify({...sessionInfo, sessionId, sessionTouched: clickTime}))
    }
  }

  _getSessionInfo() {
    if (!localStorage) {
      return null
    }

    const uiSessionInfoStr = localStorage.getItem(UI_SESSION_INFO_KEY)
    return JSON.parse(uiSessionInfoStr)
  }

  _createSessionInfo(data = {}) {
    if (localStorage) {
      const createdAt = new Date()

      localStorage.setItem(UI_SESSION_INFO_KEY, JSON.stringify({sessionId: uuid(), createdAt, sessionTouched: createdAt, ...data}))
    }
  }

  isSessionExpired = () => {
    const uiSessionInfo = this._getSessionInfo()

    if (!uiSessionInfo) {
      return true
    }

    const createdAt = new Date(uiSessionInfo.createdAt)
    const now = new Date()
    const sessionTouched = uiSessionInfo.sessionTouched ? new Date(uiSessionInfo.sessionTouched) : null

    return !(
      sessionTouched &&
      uiSessionInfo.createdAt &&
      createdAt.getDate() === now.getDate() &&
      (now.getTime() - sessionTouched.getTime() < SESSION_TIME_MILLIS)
    )
  }

  getSessionId() {
    const uiSessionInfo = this._getSessionInfo()

    if (!uiSessionInfo) {
      return null
    }

    if (this.isSessionExpired()) {
      this._createSessionInfo()
      return this.getSessionId()
    }

    return uiSessionInfo.sessionId
  }

  resetSession() {
    if (localStorage) {
      localStorage.removeItem(UI_SESSION_INFO_KEY)
    }
  }
}

